<template>
  <div>
    <el-checkbox
      v-model="isChecked"
      class="mw-0 m-r15"
      @change="onChangeCheckbox"
      :disabled="isShow"
      >运费设置</el-checkbox
    >
    <template v-if="isShow">
      <router-link :to="{ name: 'freightTempleteDetail', query: { id: freightId } }">
        <el-button type="text">{{ name }}</el-button>
      </router-link>
    </template>
    <template v-else>
      <el-select v-show="isChecked" v-model="selectedId" class="m-r15" @change="onChangeSelect">
        <el-option label="请选择" :value="0"></el-option>
        <el-option
          v-for="ft in list"
          :label="ft.templateName"
          :value="ft.id"
          :key="ft.id"
        ></el-option>
      </el-select>
      <router-link v-if="isShowNewBtn" :to="{ name: 'freightTempleteDetail' }">
        <el-button>新建运费模版</el-button>
      </router-link>
    </template>
  </div>
</template>

<script>
export default {
  name: 'FreightSet',
  props: {
    freightId: {
      type: Number
    },
    // 仅展示
    isShow: {
      type: Boolean
    },
    // 是否显示 新建运费模版 按钮
    isShowNewBtn: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isChecked: false,
      selectedId: 0,
      list: [],
      name: ''
    }
  },
  methods: {
    // 查询模版列表
    async getList() {
      const res = await this.$get('lgcenter.getLgFreightTemplateList', {
        param: {
          pageSize: 999
        }
      })
      const { success, data } = res
      if (success && data && data[0]) {
        this.list = data[0].data
      }
    },
    // TODO: 请求次数控制
    async getDetail(id) {
      this.name = ''
      if (!this.isShow || !id) return
      const res = await this.$get('lgcenter.getLgFreightTemplateDetailsById', {
        lgFreightTemplateId: id
      })
      const { success, data } = res
      if (success) {
        if (data && data[0]) {
          this.name = data[0]['templateName']
        }
      }
    },
    onChangeCheckbox(isChecked) {
      if (!isChecked) {
        this.$emit('change', 0)
      }
    },
    onChangeSelect(id) {
      this.$emit('change', id)
    },
    getIsChecked() {
      return this.isChecked
    }
  },
  watch: {
    isShow: {
      handler(newVal) {
        if (this.isShow) {
          this.getDetail(this.freightId)
        } else {
          this.getList()
        }
      },
      immediate: true
    },
    freightId: {
      handler(newVal) {
        // 初始化物流设置是否被勾选，模版 id 为 0，不勾选物流配送，反之勾选
        this.isChecked = !!this.freightId
        this.selectedId = this.freightId
        this.getDetail(this.freightId)
      },
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped>
.mw-0 {
  min-width: 0;
}
.m-r15 {
  margin-right: 15px;
}
</style>
